// extracted by mini-css-extract-plugin
module.exports = {"file-upload-wrapper":"file-upload-button__file-upload-wrapper___2v-x5","contents":"file-upload-button__contents___10ffM"};